/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneSmartOffIcon16Solid = forwardRef('TechPhoneSmartOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.707 1.293A1 1 0 0 0 .293 2.707l12.5 12.5a1 1 0 0 0 1.414-1.414L13 12.584 13 12.5v-9A2.5 2.5 0 0 0 10.5 1h-6c-.84 0-1.583.414-2.036 1.05l-.757-.757Zm2.356 2.356 1.288 1.288a1 1 0 1 0-1.288-1.288Z" }),
        React.createElement("path", { d: "m8.702 13 1.992 1.992c-.064.005-.129.008-.194.008h-6A2.5 2.5 0 0 1 2 12.5V6.298L7.702 12H5a.5.5 0 0 0 0 1h3.702Z" })));
});
